import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IdentityLayoutComponent } from '../../shared/components/identity-layout/identity-layout.component';
import { GuestVerificationComponent } from './guest-verification.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {
      path: '',
      component: IdentityLayoutComponent,
      
      children: [
        {
          path: '',
          component: GuestVerificationComponent
        },        
      ]
    }
  ])],
  exports: [RouterModule]
})
export class GuestVerificationRoutingModule { }
